import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Box,
  Container,
  Card,
  CardContent,
  useTheme,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import TransMexLogo from "../../../assets/TransMexLogo-Final_CMYK.png";
import AuthService from "../../../Services/AuthService";
import EncryptionUtils from "../../../Utils/EncryptionUtils";
import UserData from "../../../Components/Account/Login/UserData";
import i18n from "../../../i18n";

export default function Login({ onLogin, config }) {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isRemembered, setIsRemembered] = useState(false);
  const authService = new AuthService();
  const theme = new useTheme();

  const handleLogin = async () => {
    const result = await authService.login(
      `${config.url}/api/User/login`,
      email,
      password,
      isRemembered,
    );
    // console.log(result)
    if (result.data !== undefined) {
      const userDataUser = new UserData(result.data);
      localStorage.setItem(
        "permissions",
        JSON.stringify(userDataUser.user.permisosWebUsuarios)
      );
      //Configurar empresa
      if(result.data.User.IdEmpresa){
        localStorage.setItem("empresa", result.data.User.IdEmpresa)
      }
      // Configurar el idioma del usuario
      if (result.data.Language) {
        const idioma = result.data.Language; // ej: "es-MX"
        const idiomaBase = idioma.split("-")[0]; // "es"
        // console.log('Login - Configurando idioma del usuario:', idiomaBase);
        localStorage.setItem("language", idiomaBase);
        await i18n.changeLanguage(idiomaBase);
      } else {
        // Si no hay idioma en la respuesta, usar el idioma del usuario en la BD
        const userLanguage = userDataUser.idLanguage;
        const idiomaBase = userLanguage === 1 ? "es" : "en";
        // console.log('Login - Configurando idioma por ID del usuario:', idiomaBase);
        localStorage.setItem("language", idiomaBase);
        await i18n.changeLanguage(idiomaBase);
      }
      
      EncryptionUtils.storeEncryptedData("user", JSON.stringify(userDataUser));
      onLogin(userDataUser);
    }
  };
  const handleChange = (event) => {
    setIsRemembered(event.target.checked);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (email === "") {
      setEmailError(t("account.login.emailRequired"));
    }

    if (password === "") {
      setPasswordError(t("account.login.passwordRequired"));
    }

    if (email !== "" && password !== "") {
      handleLogin();
    }
  };

  return (
    <Card
      sx={{
        margin: "auto",
        marginTop: 10,
        maxWidth: "380px",
      }}
    >
      <CardContent>
        <Container>
          <CssBaseline />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              src={TransMexLogo}
              alt={t("navigation.logoAlt")}
              style={{
                maxWidth: "100%", // Utilizando porcentaje para ajustarse al contenedor
                maxHeight: "auto", // Para mantener la proporción de la imagen
                marginTop: "50px",
              }}
            />
            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ mt: 1, textAlign: "center", marginTop: "80px" }}
            >
              <TextField
                margin="normal"
                variant="standard"
                fullWidth
                sx={{ maxWidth: "300px" }}
                id="email"
                label={t("account.login.email")}
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={!!emailError}
                helperText={emailError}
              />
              <TextField
                margin="normal"
                variant="standard"
                fullWidth
                sx={{ maxWidth: "300px" }}
                name="password"
                label={t("account.login.password")}
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={!!passwordError}
                helperText={passwordError}
              />
              <Grid container justifyContent="flex-start">
                <FormControlLabel
                  margin="normal"
                  variant="standard"
                  sx={{ mb: 1, maxWidth: "300px" }}
                  control={
                    <Checkbox
                      name="isRemembered"
                      id="isRemembered"
                      checked={isRemembered}
                      onChange={(e) => handleChange(e)}
                    />
                  }
                  label={t("account.login.rememberMe")}
                />
              </Grid>
              <Grid container justifyContent="center">
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    sx={{
                      mt: 2,
                      mb: 2,
                      width: "150px",
                      bgcolor: theme.palette.primary.main,
                    }}
                  >
                    {t("account.login.enter")}
                  </Button>
                </Grid>
              </Grid>
              <Grid container justifyContent="center">
                <Grid item xs>
                  <Link
                    component={RouterLink}
                    to="/Account/ForgotPassword"
                    variant="body2"
                  >
                    {t('account.login.forgotPassword')}
                  </Link>
                </Grid>
                <Grid container justifyContent="center">
                <Link
                    component={RouterLink}
                    to="/Account/AvisoPrivacidad"
                    variant="body2"
                  >
                    {t('account.login.privacyNotice')}
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Container>
      </CardContent>
    </Card>
  );
}
